import React from "react";
import { useStockStatisticModel } from "../stockStatisticModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel from "@/model/globalModel";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData,
        whDs
    } = useStockStatisticModel();
    const { userBranch } = useGlobalModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Select,
            placeholder: "是否有占用",
            fieldName: ["ci", "vrm", "bcm"].includes(userBranch) ? 'occupy' : "isOccupy",
            options: ["ci", "vrm", "bcm"].includes(userBranch) ?
                [{ label: "是", value: 0 }, { label: "否", value: null }]
                : [{ label: "是", value: 1 }, { label: "否", value: 0 as any }],
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "商品名称",
            fieldName: "materialName"
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "商品编号",
            fieldName: "materialCode"
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "替换编号",
            fieldName: "replaceCode"
        },
        ["ci", "vrm", "bcm"].includes(userBranch) ? {
            type: SearchTypeEnum.Select,
            placeholder: "仓库",
            fieldName: "warehouseCode",
            options: whDs
        } : {
            type: SearchTypeEnum.Select,
            placeholder: "仓库",
            fieldName: "warehouseCodeList",
            mode: "multiple",
            options: whDs
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "货位",
            fieldName: "shelfCode",
        },
    ]

    return (
        <YhPageHeader
            title="库存统计"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}